module.exports = __webpack_public_path__ + "img/1448098533.b0ebb9a2.jpg";